import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { viewSIDoc } from "../services/tractorDataService";
import { getTransporterList } from "../services/dataService";
import { filter } from "lodash";
import { PulseLoader } from "react-spinners";

function DailyEmailHeaderTemplate({
	factoryCheckboxCheck,
	JDCheckboxCheck,
	transporterCheckboxCheck,
	setToRecipientId,
	setCCRecipientId,
	setFactoryCheckboxCheck,
	setJDCheckboxCheck,
	setTransporterCheckboxCheck,
	ToRecipientId,
	CCRecipientId,
	emailBtn,
	sendEmailHandler,
	loading,
	allowToSend,
	emailData,
	show,
	hide,
}) {
	const [recipientLoader, setRecipientLoader] = useState(false)
	const onChangeRecipientTo = (e) => {
		setToRecipientId(e.target.value);
	};
	const onChangeRecipientCC = (e) => {
		setCCRecipientId(e.target.value);
	};
	const factoryCheckboxChangeHandler = (e) => {
		setFactoryCheckboxCheck(e.target.checked);
	};
	const JDCheckboxChangeHandler = (e) => {
		setJDCheckboxCheck(e.target.checked);
	};
	const transporterCheckboxChangeHandler = (e) => {
		setTransporterCheckboxCheck(e.target.checked);
	};

	useEffect(() => {
		for (let i = 0; i < emailData.length; i++) {
			async function viewDocFunction() {
				try {
				const response = await viewSIDoc(emailData[i].BookingDocument);
				emailData[i].bookingDocLink = response.data.Message
				} catch (error) {}
			}
			viewDocFunction();
		}
  	},[emailData]);

	  useEffect(() => {
		async function getTransporterData() {
			try {
			  setRecipientLoader(true)
			  const response = await getTransporterList();
			  const filteredTransporterEmail = filter(response.data, {
				  TransporterName: emailData[0].Transporter,
			  });
			  for (let i = 0; i < filteredTransporterEmail.length; i++) {
				if (filteredTransporterEmail[i].Type === "to") {
				  setToRecipientId(filteredTransporterEmail[i].EmailList);
				}
				if (filteredTransporterEmail[i].Type === "cc") {
				  setCCRecipientId(filteredTransporterEmail[i].EmailList);
				}
			  }
			  setRecipientLoader(false)
			} catch (error) {
			  setRecipientLoader(false)
			}
		}
		getTransporterData();
	  }, [emailData, setToRecipientId, setCCRecipientId]);
	return (
		<>
			<Modal
				show={show}
				centered
				dialogClassName="dailyEmailTemplateModalWidth"
				contentClassName="dailyEmailTemplateModalHeight"
			>
				<Modal.Body>
					<div style={{ display: "flex" }}>
						<h3>Send Email</h3>
						<button className="dailyEmailTemplate__closeBtn" onClick={hide}>
							<i class="bx bxs-x-square"></i>
						</button>
					</div>
					<div className="emailWindow__email_container">
						<div className="emailWindow__checkbox_div">
							<div className="emailWindow__recipientName">
								<input
									type="checkbox"
									onChange={factoryCheckboxChangeHandler}
									value={factoryCheckboxCheck}
								/>
								<label className="emailWindow__columnName_RecipientLabel">
									- Factory
								</label>
							</div>
							<div className="emailWindow__recipientName">
								<input
									type="checkbox"
									onChange={JDCheckboxChangeHandler}
									value={JDCheckboxCheck}
								/>
								<label className="emailWindow__columnName_RecipientLabel">
									- JD
								</label>
							</div>
							<div className="emailWindow__recipientName">
								<input
									type="checkbox"
									onChange={transporterCheckboxChangeHandler}
									value={transporterCheckboxCheck}
								/>
								<label className="emailWindow__columnName_RecipientLabel">
									- Transporter
								</label>
							</div>
						</div>
						<div
							className="emailWindow__recipientName"
							style={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
							}}
						>
							<label className="emailWindow__columnName_RecipientLabel">
								Transporter Recipient (To)
							</label>
							<p style={{color:"red", marginBottom:"0px"}}>*</p>
							<label style={{color:"black", marginLeft:"5px", marginBottom:"0px"}} className="emailWindow__columnName_RecipientLabel">-</label>
							<input
								className="recipientNameClass_dailyEmail"
								disabled={!transporterCheckboxCheck}
								onChange={onChangeRecipientTo}
								name="ToRecipientId"
								value={ToRecipientId}
							/>
							{recipientLoader && (
								<PulseLoader
									color="#007bff"
									size="20px"
									margin="10px"
									style={{ position: "absolute", top: "220px", left: "40%" }}
								/>
							)}
						</div>
						<div
							className="emailWindow__recipientName"
							style={{
								display: "flex",
								flexDirection: "column",
								width: "100%",
							}}
						>
							<label className="emailWindow__columnName_RecipientLabel">
								Transporter Recipient (CC) -
							</label>
							<input
								className="recipientNameClass_dailyEmail"
								disabled={!transporterCheckboxCheck}
								onChange={onChangeRecipientCC}
								name="CCRecipientId"
								value={CCRecipientId}
							/>
							{recipientLoader && (
								<PulseLoader
									color="#007bff"
									size="20px"
									margin="10px"
									style={{ position: "absolute", top: "360px", left: "40%" }}
								/>
							)}
						</div>
						<div>
							<Button
								className="btn-primary sendMailBtn"
								onClick={sendEmailHandler}
								disabled={
									!(
										factoryCheckboxCheck ||
										JDCheckboxCheck ||
										transporterCheckboxCheck
									) || loading === true
								}
								style={{ position: "relative", top: "20px", left: "89%" }}
							>
								<i class="bx bxs-send"></i>
							</Button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default DailyEmailHeaderTemplate;
